import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  Button,
} from "@mui/material";
import { useTranslation } from "i18n-fe";
import { useNavigate } from "react-router-dom";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import PageBreadcrumbs from "../components/PageBreadcrumbs";
import { useResults } from "../hooks/useResults";

function ResultsPage() {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { comps, loading, error } = useResults();

  const handleUploadClick = () => {
    navigate("/results/upload");
  };

  // Removed handleCompClick - navigation is now handled inline with compYear

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <PageBreadcrumbs items={[{ label: t("results.title") }]} />
        </Box>
        <Button
          variant="contained"
          startIcon={<UploadFileIcon />}
          onClick={handleUploadClick}
        >
          {t("results.uploadButton")}
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <TableContainer component={Paper}>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="200px"
          >
            <CircularProgress />
          </Box>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("results.columns.compId")}</TableCell>
                <TableCell>{t("results.columns.showName")}</TableCell>
                <TableCell>{t("results.columns.compYear")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {comps.map((comp) => {
                // Create a unique key from compYear and compId
                const uniqueKey = comp.compYear && comp.compId
                  ? `${comp.compYear}-${comp.compId}`
                  : comp.compId || `comp-${comp.showName || 'unknown'}`;

                return (
                  <TableRow
                    key={uniqueKey}
                    hover
                    onClick={() => {
                      if (comp.compYear && comp.compId) {
                        navigate(`/results/${comp.compYear}/${comp.compId}`);
                      }
                    }}
                    sx={{
                      cursor: comp.compYear && comp.compId ? "pointer" : "default",
                      "&:last-child td, &:last-child th": { border: 0 },
                      ...(!comp.compYear || !comp.compId ? { opacity: 0.6 } : {}),
                    }}
                  >
                    <TableCell>{comp.compId}</TableCell>
                    <TableCell>{comp.showName}</TableCell>
                    <TableCell>{comp.compYear || "-"}</TableCell>
                  </TableRow>
                );
              })}
              {comps.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    {t("results.empty")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </Box>
  );
}

export default ResultsPage;
